var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from '@rad/components/ui/modal';
import Input from '@rad/components/inputs/input';
import ActionButton from '@rad/components/ui/action-button';
import { inviteToTenant } from '../../../common/network/community';
import { updateUserRoles } from '../../../common/network/users';
import { useToast } from '../../../contexts/toast';
import RolePicker from './role-picker';
const AddPersonModal = (props) => {
    const toast = useToast();
    const [email, setEmail] = useState('');
    const [stage, setStage] = useState({ kind: 'email' });
    const [selectedRoles, setSelectedRoles] = useState([]);
    const close = () => {
        setEmail('');
        setStage({ kind: 'email' });
        setSelectedRoles([]);
        props.onClose();
    };
    const handleAdd = () => __awaiter(void 0, void 0, void 0, function* () {
        const [success, res] = yield inviteToTenant(email);
        if (!success) {
            toast.error(res.map(e => e.message).join('\n'));
            return;
        }
        props.onChanged();
        if (res.status === 'added' && res.userId) {
            setStage({ kind: 'roles', userId: res.userId, email });
        }
        else if (res.status === 'already-invited') {
            toast.error(`${email} has already been invited. They are on the Invitations tab.`);
        }
        else {
            setStage({ kind: 'invited', email });
        }
    });
    const handleSaveRoles = () => __awaiter(void 0, void 0, void 0, function* () {
        if (stage.kind !== 'roles')
            return;
        if (selectedRoles.length === 0) {
            toast.success(`${stage.email} has been added.`);
            close();
            return;
        }
        const [success] = yield updateUserRoles(stage.userId, selectedRoles);
        if (!success) {
            toast.error('They were added, but their role could not be saved. You can set it from their row.');
            close();
            return;
        }
        props.onChanged();
        toast.success(`${stage.email} has been added.`);
        close();
    });
    return (_jsxs(Modal, { isOpen: props.isOpen, title: "Add a person", onClose: close, footer: stage.kind === 'email' ? (_jsx(ActionButton, { className: "btn btn-primary", onClick: handleAdd, disabled: !email, loadingText: "Adding...", children: "Continue" })) : stage.kind === 'roles' ? (_jsx(ActionButton, { className: "btn btn-primary", onClick: handleSaveRoles, loadingText: "Saving...", children: "Done" })) : (_jsx("button", { className: "btn btn-primary", onClick: close, children: "Done" })), children: [stage.kind === 'email' && _jsxs(_Fragment, { children: [_jsx("p", { children: "Enter their email address. If they already have a 76UNBOXED account they will be added right away. If not, we will email them an invitation and they will join as soon as they set up their account." }), _jsx(Input, { label: "Email address", kind: "email", value: email, onChange: setEmail })] }), stage.kind === 'roles' && _jsxs(_Fragment, { children: [_jsxs("p", { children: [_jsx("strong", { children: stage.email }), " has been added to this community."] }), _jsx("p", { children: "Does this person do any work for this community? Tick what applies. If they are just a resident, leave everything unticked and press Done." }), _jsx(RolePicker, { roles: props.roles, value: selectedRoles, onChange: setSelectedRoles })] }), stage.kind === 'invited' && _jsxs(_Fragment, { children: [_jsxs("p", { children: ["We have emailed an invitation to ", _jsx("strong", { children: stage.email }), "."] }), _jsx("p", { className: "mb-0", children: "They will appear on this page once they set up their account, and you can give them a role then. Until then you will find them on the Invitations tab." })] })] }));
};
export default AddPersonModal;
